import React, { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import api from "@/lib/api";
import { Input, Select } from "@/components/Field";

export function CustomerSelect({ value, onChange, testid }) {
  const [customers, setCustomers] = useState([]);
  useEffect(() => { api.get("/users", { params: { role: "customer" } }).then((r) => setCustomers(r.data)).catch(() => {}); }, []);
  return (
    <Select testid={testid} value={value || ""} onChange={(e) => {
      const c = customers.find((x) => x.id === e.target.value);
      onChange(e.target.value, c ? c.name : "");
    }}>
      <option value="">— Kunde wählen —</option>
      {customers.map((c) => <option key={c.id} value={c.id}>{c.name} ({c.email})</option>)}
    </Select>
  );
}

export function ItemsEditor({ items, setItems }) {
  const add = () => setItems([...items, { name: "", qty: 1, price: 0 }]);
  const upd = (i, k, v) => { const n = [...items]; n[i] = { ...n[i], [k]: k === "name" ? v : Number(v) }; setItems(n); };
  const del = (i) => setItems(items.filter((_, j) => j !== i));
  const total = items.reduce((s, it) => s + (it.price || 0) * (it.qty || 1), 0);
  return (
    <div className="space-y-2">
      {items.map((it, i) => (
        <div key={i} className="flex gap-2 items-center" data-testid={`item-${i}`}>
          <Input testid={`item-name-${i}`} placeholder="Position" value={it.name} onChange={(e) => upd(i, "name", e.target.value)} />
          <input type="number" className="w-16 rounded-md border border-input bg-background px-2 py-2.5 text-sm" value={it.qty} onChange={(e) => upd(i, "qty", e.target.value)} data-testid={`item-qty-${i}`} />
          <input type="number" className="w-24 rounded-md border border-input bg-background px-2 py-2.5 text-sm" value={it.price} onChange={(e) => upd(i, "price", e.target.value)} data-testid={`item-price-${i}`} />
          <button type="button" onClick={() => del(i)} className="p-2 hover:text-destructive"><Trash2 size={15} /></button>
        </div>
      ))}
      <div className="flex justify-between items-center pt-1">
        <button type="button" onClick={add} className="btn-ghost !py-1.5 !px-3 text-xs" data-testid="item-add"><Plus size={14} /> Position</button>
        <span className="text-sm font-semibold">Netto: {total.toFixed(2)} €</span>
      </div>
    </div>
  );
}
